import { render, staticRenderFns } from "./view-sale-order.vue?vue&type=template&id=232b46a1&"
import script from "./view-sale-order.vue?vue&type=script&lang=ts&"
export * from "./view-sale-order.vue?vue&type=script&lang=ts&"
import style0 from "./view-sale-order.vue?vue&type=style&index=0&id=232b46a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports